import { Tooltip, tooltipClasses, TooltipProps } from "@mui/material";
import { styled } from "@mui/material/styles";

const CustomTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#fff",
    color: "#1D2433",
    fontSize: "14px",
    borderRadius: "8px",
    padding: "8px",
    boxShadow: "0 4px 6px 0 rgba(0, 0, 0, 0.13)",
    fontFamily: "EnergyRegular, sans-serif",
    maxWidth: "164px",
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: "#fff",
  },
}));

export default CustomTooltip;
